import React from 'react';
import { GetStaticProps } from 'next';
import { getStaticPathsForNewsDetail } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForNewsDetail';
import { getLocaleFromPath } from '../../../../../features/shared/i18n/locale/getLocaleFromPath';
import { defaultLocale } from '../../../../../features/shared/i18n/locale/constants/default';
import { getEnrichedPageById } from '../../../../../features/app/pages/domain/use-cases/getEnrichedPageById';
import { IDetailPageData } from '../../../../../features/news/domain/models/IDetailsPageData';
import DetailsPage from '../../../../../features/news/ui/DetailsPage';
import {
	getAllBlogItemsById,
	getAllBlogItemsSlugs,
} from '../../../../../features/news/domain/use-cases/blog-items';
import { NewsPageId } from '../../../../../features/app/pages/domain/constants/PageId';

const Page = ({ page, post }: IDetailPageData) => (
	<DetailsPage page={page} post={post} />
);

export const getStaticPaths = async () =>
	getStaticPathsForNewsDetail(getAllBlogItemsSlugs);

export const getStaticProps: GetStaticProps = async ({ params }) => {
	const locale = getLocaleFromPath(params?.locale ?? '') ?? defaultLocale;
	const [page, blogItems] = await Promise.all([
		getEnrichedPageById(NewsPageId.BlogDetailPage, locale),
		getAllBlogItemsById(params?.slug as string, locale),
	]);

	if (!page || !blogItems) {
		return {
			notFound: true,
		};
	}

	return {
		props: {
			page,
			post: blogItems,
		},
	};
};

export default Page;
